import * as angular from 'angular';

const CommonsLoginConstants = {
    SSO_COOKIES: {
        LOGGED_TOKEN: 'IBERIACOM_SSO_ACCESS',
        LOGGED_TOKEN_EXPIRATION: 'IBERIACOM_SSO_ACCESS_TO',
        LOGGED_REFRESH_TOKEN: 'IBERIACOM_SSO_REFRESH',
        LOGGED_REFRESH_TOKEN_EXPIRATION: 'IBERIACOM_SSO_REFRESH_TO',
        ONB_LOGGED_TOKEN: 'IBERIACOM_SSO_ONB_ACCESS',
        ONB_LOGGED_TOKEN_EXPIRATION: 'IBERIACOM_SSO_ONB_ACCESS_TO',
        ONB_LOGGED_REFRESH_TOKEN: 'IBERIACOM_SSO_ONB_REFRESH',
        ONB_LOGGED_REFRESH_TOKEN_EXPIRATION: 'IBERIACOM_SSO_ONB_REFRESH_TO',
        SF_LOGGED_TOKEN: 'IBERIACOM_SSO_ACCESS_SALESFORCE',
        SF_LOGGED_TOKEN_EXPIRATION: 'IBERIACOM_SSO_ACCESS_TO_SALESFORCE',
        SF_LOGGED_REFRESH_TOKEN: 'IBERIACOM_SSO_REFRESH_SALESFORCE',
        SF_LOGGED_REFRESH_EXPIRATION: 'IBERIACOM_SSO_REFRESH_TO_SALESFORCE',
        DEFAULT_EXPIRY_TIME: 1000 * 60 * 60 * 24 * 365 * 10, //ten years
        DEFAULT_PATH: '/',
        SESSION_INFO: 'IBERIACOM_SSO_SESION'
    },
    OB_ROLES_WITH_PERMISSION: [
        'I_COMP_AUT',
        'I_COMP_ADM'
    ],
    ERROR_MESSAGES: {
        606: 'ERROR_SSO_606',
        302: 'ERROR_SSO_302',
        609: 'ERROR_SSO_609'
    },
    URL_PARAMETERS: {
        ERROR: 'codeError'
    },
    LOGIN_ONB: 'ONB'
};

angular.module('ib-commons-login-module', []);
angular.module('ib-commons-login-module').constant('CommonsLoginConstants', CommonsLoginConstants);

export {CommonsLoginConstants};
export type CommonsLoginConstantsType = typeof CommonsLoginConstants;
